<script setup lang="ts">
import { useThemeSettingSupportModal } from '@/components/theme/edit/theme-setting-support-modal/useThemeSettingSupportModal';
import {
  GeneratedQuery,
  Keyword,
  OpenPopupParam,
} from '@/types/themeQueryGenerationRequest';

export interface Props {
  keywordDataset: GeneratedQuery['keywords'];
  excludedKeywords: GeneratedQuery['excluded_keywords'];
  lang: 'ja' | 'en';
}
defineProps<Props>();

const emit = defineEmits<{
  (e: 'open-popup', param: OpenPopupParam): void;
}>();

const { wrapIfSpaceExists } = useThemeSettingSupportModal();

const openPopup = (
  event: MouseEvent,
  keyword: OpenPopupParam['word'],
  lang: 'ja' | 'en',
) => {
  emit('open-popup', {
    event,
    word: keyword,
    lang,
    isDeletedKeyword: false,
  });
};
const generateKeyForKeywordData = (keywordData: Array<Keyword>) => {
  return keywordData.map(data => `${data.uuid}`).join('-');
};
</script>

<template>
  <template
    v-for="(keywordData, keywordDataIndex) in keywordDataset"
    :key="generateKeyForKeywordData(keywordData)"
  >
    <span>(</span>
    <template
      v-for="(keyword, keywordIndex) in keywordData"
      :key="keyword[lang]"
    >
      <span
        class="popup-trigger"
        @click="openPopup($event, keyword, lang)"
        @click.stop
        role="button"
      >
        {{ wrapIfSpaceExists(keyword[lang]) }}
      </span>
      <span v-if="keywordIndex !== keywordData.length - 1">&nbsp;OR&nbsp;</span>
    </template>
    <span>)</span>
    <span v-if="keywordDataIndex !== keywordDataset.length - 1"
      >&nbsp;AND&nbsp;</span
    >
  </template>
  <template
    v-for="excludedKeyword in excludedKeywords"
    :key="excludedKeyword.ja"
  >
    <span
      class="popup-trigger"
      @click="openPopup($event, excludedKeyword, lang)"
      @click.stop
      role="button"
    >
      -{{ wrapIfSpaceExists(excludedKeyword[lang]) }}
    </span>
  </template>
</template>

<style lang="scss" scoped>
.popup-trigger {
  cursor: pointer;
  &:hover {
    background: $color-gray400;
    border-radius: 4px;
  }
}
</style>
